import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL, privilegeURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import ReactLoading from "react-loading";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreateNotification = (props) => {
  const { user, authToken, accessTokenPrivilege } = useSelector((state) => state.auth);

  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Notification" }));
  const history = useHistory();

  const [start_date, setStart_date] = useState('');

  const [event, setEvent] = useState(null);
  const [listEvent, setListEvent] = useState([]);
  const [target, setTarget] = useState(null);
  const [listTarget, setListTarget] = useState([]);
  const [campaign, setCampaign] = useState('');
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const AlertError = (message) => {
    Swal.fire("Item key!", message, "error");
  };

  const getListEvent = async () => {
    const apiUrls = `${baseURLV1}/eventType?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListEvent(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getListTarget = async () => {
    const apiUrls = `${baseURLV1}/targetGroup?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListTarget(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getStartData = async () => {
    // await getListEvent()
    await getListTarget()
  }


  useEffect(() => {
    getStartData()
  }, []);

  /*const handleChangeGroup = (event) => {
    console.log(event.target.value)
    setgroupID(event.target.value);
  };

  const handleChangeProduct = (event) => {
    console.log(event.target.value)
    setproductID(event.target.value);
  };*/

  const onSubmit = async () => {
    // console.log({type: type, list: list, campaign});
    let dateFrom = {}
    if (target == null || target == '') {
      return AlertError("กรุณาเลือก กลุ่มเป้าหมาย!!");
    }

    if (campaign == undefined || campaign == '') {
      return AlertError("กรุณาใส่ ชื่อแคมเปญ !!");
    }

    if (description == undefined || description == '') {
      return AlertError("กรุณาใส่ รายละเอียดแคมเปญ !!");
    }

    if (start_date == undefined || start_date == "") {
      return AlertError("กรุณาใส่ วันที่เริ่มส่ง !!");
    } else if (start_date != '') {
      dateFrom = {
        push_date: start_date
      }
    }

    var events = {
      // event_type_id: event == '' ? null : event,
      group_condition_id: target == '' ? null : target,
      title_th: campaign,
      title_en: campaign,
      message_th: description,
      message_en: description,
      ...dateFrom,
    };

    let apiUrls = `${baseURLV1}/pushNotification`;
    let token = localStorage.getItem("Token");
    setIsLoading(true)
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        setIsLoading(false)
        history.goBack();
      })
      .catch((err) => {
        setIsLoading(false)
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง Notification. !! " + err,
          "error"
        );
      });
  };

  return (
    <>
      <Card>
        <CardHeader title="Create Notification"></CardHeader>
        <CardBody>

          {/* <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ประเภทอีเว้นท์" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={event}
              onChange={(e) => {
                // console.log(e.target.value)
                setEvent(e.target.value)
              }}
            >
              <option value={null}>
                All
              </option>
              {listEvent &&
                listEvent.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.description_th}
                    </option>
                  );
                })}

            </select>
          </div> */}

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "กลุ่มเป้าหมาย" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={target}
              onChange={(e) => {
                // console.log(e.target.value)
                setTarget(e.target.value)
              }}
            >
              <option value={null} hidden>
                กรุณาเลือก
              </option>
              {listTarget &&
                listTarget.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.title_th}
                    </option>
                  );
                })}

            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ข้อความสำหรับส่งแจ้งเตือน" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={campaign}
              onChange={(e) => setCampaign(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียด" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่เริ่มส่ง" })}:{" "}
            </p>
            {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
              <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setStart_date(data.target.value === "NULL" ? null : data.target.value)
                }
              />
            </div>*/}
            <TextField
              //disabled={!(!claimNoRef && !isSubmit) || is_reference}
              id="DateFrom"
              type="datetime-local"
              //label={intl.formatMessage({ id: "###", defaultMessage: " " })}
              className=" mb-3 mr-3"
              value={start_date}
              InputProps={{ inputProps: { min: (new Date).toISOString().slice(0, 16) } }}
              style={{
                height: '15px',
                //width: '20px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                setStart_date(name.target.value)
              }}
            />
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/Notification">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {isLoading ? (
                <ReactLoading
                  type={"bars"}
                  color={"white"}
                  height={30}
                  width={30}
                />
              ) : 'Save'}
              {/*intl.formatMessage({ id: "###", defaultMessage: "Save" })*/}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
